import { trpc } from '../utils/trpc';
import { useSession } from 'next-auth/react';

export const useMe = () => {
  const { data: session } = useSession();
  const {
    data: me,
    refetch,
    isLoading,
    isFetching,
    isInitialLoading,
  } = trpc.users.getMe.useQuery(undefined, {
    // ~90 components call useMe. With the default staleTime of 0, every one
    // that mounted refetched `me`, and each refetch re-rendered AppProvider and
    // every consumer twice (isFetching on, then off) - on Territory Insights,
    // scrolling a list re-rendered ~14k components per batch of new cards.
    // Explicit refetch()/invalidations are unaffected, and focus or navigation
    // after 30s still refreshes it.
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    enabled: !!session,
    throwOnError: true,
    trpc: {
      context: {
        skipBatch: true,
      },
    },
  });
  const isLoadingMe = isLoading || isFetching;
  return {
    me,
    session,
    refetch,
    isLoadingMe,
    isInitialLoading,
  };
};
